import React, { useEffect, useState, useCallback } from "react";
import { Container, Row } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import AllOrders from "./AllOrders";
import { toast } from "react-toastify";
import { APIClient } from "../../../helpers/api_helper";

const apiClient = new APIClient();

const Retiradas = ({ isLojista, isCliente, isAdmin }) => {
  const [loading, setLoading] = useState(false);
  const [orderList, setOrderList] = useState([]);
  const [shouldFetch, setShouldFetch] = useState(true);
  const [saldos, setSaldos] = useState([]);

  const user = JSON.parse(localStorage.getItem("authUser"));

  const getSaldos = useCallback(async () => {
    setLoading(true);
    const response = await apiClient.get(`/saldo/${user.data._id}/ALL`);
    
    if (response.sucesso) {
      setSaldos(response.dados);
    } else {
      toast.error(response.mensagem);
    }
    setLoading(false);
  }, [user.data._id]);

  const fetchBtcTransactions = useCallback(
    async (user_id) => {
      setLoading(true);
      const response = await apiClient.get(`/retiradas-cripto/${user_id}/ALL`);
      console.log(response);
      
      if (response.sucesso) {
        return response.dados;
      } else {
        toast.error(response.mensagem);
        return [];
      }
    },
    []
  );

  useEffect(() => {
    if (shouldFetch) {
      setLoading(true);
      const fetchData = async () => {
        const retorno = await fetchBtcTransactions(
          isLojista || isCliente ? user.data._id : 0
        );
        setOrderList(retorno);
        setShouldFetch(false);
        getSaldos();
      };

      fetchData();
      setLoading(false);
    }
  }, [
    shouldFetch,
    isLojista,
    isCliente,
    user.data._id,
    fetchBtcTransactions,
    getSaldos,
  ]);

  document.title = "Retiradas | Painel Fort Exchange";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="Retiradas Cripto"
            pageTitle={
              isLojista ? "Lojista" : isCliente ? "Clientes Fort" : "Aplicações"
            }
          />
          <Row>
            <AllOrders
              isCliente={isCliente}
              isLojista={isLojista}
              user={user}
              orderList={orderList}
              loading={loading}
              setShouldFetch={setShouldFetch}
            />
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Retiradas;
